export const hotelShow: any = {
  localGuide: "Local Guide",
  localInformation: "Local Information",
  roomNotAvailableMessage: "There were no vacancies on the dates specified.",
  hotelFacilitiesAndServices: "Hotel Facilities / Services",
  hotelPolicies: "Hotel Policies",
  facilitiesAndServices: "Facilities / Services",
  serviceChargesAndOptionalFees: "Service Charges / Optional Fees",
};
